import React, { Component } from "react";
import '../Configuration.css';
import { Box, Paper, TextField, Button, Stack, Tooltip, Grid, Autocomplete, Typography } from "@mui/material";
import CommonGridHeader, { CommonDeleteButton, DeletePopup } from "../../../Components/Common Components/CommonComponents";
import { DataGrid } from '@mui/x-data-grid';
import { withTranslation } from 'react-i18next';
import { Colors } from "../../../Styles/Colors";
import ToastMsg from '../../../Components/ToastMsg/ToastMsg';
import RestAPIService from "../../../Utility/Services/RestAPIService";
import { Serviceurls } from "../../../Utility/API/Serviceurls";
import { CheckAccessFunc } from "../../../Components/CommonFunctions/CommonFunctions";

class BankDetailsMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            bankMasterList: [],
            bankData: null,
            bankName: '',
            accountNo: '',
            current_page: 0,
            rowsPerPage: 10,
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: "",
        }
    }
    componentDidMount = () => {
        this.getBankMasterList()
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }


    getBankMasterList = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAll(Serviceurls.GET_MASTER_BANK_DATA)
                .then(response => {
                    if (response.data.status === "success") {
                        this.setState({
                            bankMasterList: response.data?.data || [],
                        }, () => {
                            this.LoaderFunction(false)
                        });
                    }
                })
                .catch(error => {
                    this.LoaderFunction(false)
                    if (error?.response?.data?.status === "fail" || error?.response?.status == 404) {
                        this.responseSuccessErrorMessage(error.response.data.message || error?.response?.statusText, false);
                    }
                });
        } catch (e) {
            this.LoaderFunction(false)
            this.responseSuccessErrorMessage(e.message, false);
        }
    }

    responseSuccessErrorMessage(message, type) {
        this.setState({
            showSuccessResponse: message ? type : false,
            showErrorResponse: message ? !type : false,
            responseMessage: message
        })
    }

    handleChange = (event) => {
        let { name, value } = event.target;
        value = value.trimStart();

        let states = this.state;
        let isValid = true;

        switch (name) {
            case "bankName":
                isValid = /^[A-Za-z\s]*$/.test(value);
                if (!isValid) return;
                if (value.length > 60) return;
                break;

            case "accountNo":
                isValid = /^[0-9]*$/.test(value);
                if (!isValid) return;
                if (value.length > 20) return;
                break;

            default:
                if (value.length > 100) return;
                break;
        }

        states[name] = value;
        this.setState({ states });
    };


    renderTextBox(label, statekey) {
        const { t } = this.props;
        let states = this.state;
        return (
            <div className="eMed_expConfig_txtbox">
                <TextField
                    fullWidth
                    size="small"
                    autoComplete="off"
                    label={t(label)}
                    name={statekey}
                    required
                    value={states[statekey] ? states[statekey] : ""}
                    onChange={this.handleChange}
                />
            </div>
        )
    }

    handleClear = () => {
        this.setState({
            bankName: "",
            accountNo: "",
            bankData: null,
        })
    }

    handledelete = (data) => {
        this.setState({
            bankData: data ? data : null,
        })
    }

    handleSave = () => {
        const { t } = this.props
        let { bankName, accountNo } = this.state;
        let isAvl = true;
        let Message = "";
        if (!bankName || !accountNo) { isAvl = false; Message = "Fillmandatory" }
        if (isAvl) {
            let datas = {
                "bank_name": bankName ? bankName : '',
                "bank_account_number": accountNo ? accountNo : '',
            }
            try {
                this.LoaderFunction(true)
                this.setState({ disableBtn: true })
                RestAPIService.create(datas, Serviceurls.GET_MASTER_BANK_DATA)
                    .then(response => {
                        if (response.data.status === "success") {
                            this.handleClear();
                            this.getBankMasterList();
                            this.LoaderFunction(false)
                            this.setState({ disableBtn: false })
                            this.responseSuccessErrorMessage(response.data.message, true);
                        }
                    })
                    .catch(error => {
                        if (error?.response?.data?.status === "fail") {
                            this.LoaderFunction(false)
                            this.setState({ disableBtn: false })
                            this.responseSuccessErrorMessage(error.response.data.message, false);
                        }
                    });
            } catch (e) {
                this.LoaderFunction(false)
                this.responseSuccessErrorMessage(e.message, false);
            }
        } else {
            this.LoaderFunction(false)
            this.responseSuccessErrorMessage(t(Message), false)
        }
    }

    msgClose() {
        this.setState({
            showSuccessResponse: false,
            showErrorResponse: false,
            responseMessage: ''
        })
    }

    popupClose() {
        this.setState({ bankData: null })
    }

    deletePov() {
        try {
            let data = {
                "bank_id": this.state.bankData ? this.state.bankData?.id : null,
            }
            RestAPIService.delete(Serviceurls.GET_MASTER_BANK_DATA, data).
                then((response) => {
                    if (response.data.status === "success") {
                        this.responseSuccessErrorMessage(response.data.message, true)
                        this.setState({ bankData: null, }, () => {
                            this.getBankMasterList()
                            this.handleClear()
                        })
                    } else {
                        this.responseSuccessErrorMessage(response.data.message, false)
                    }
                }).catch(error => {
                    this.responseSuccessErrorMessage(error.message, false)
                })
        }
        catch (e) {
            this.responseSuccessErrorMessage(e.message, false)
        }
    }

    render() {
        const { t } = this.props;
        let { rowsPerPage, current_page, bankMasterList } = this.state;
        const columns = [
            { field: 's.no', headerName: t('SNo'), sortable: false, flex: 0.05, renderCell: (index) => index.api.getRowIndex(index.row.id) + 1 },
            {
                field: 'bank_name', headerName: t('Bank Name'), sortable: false, flex: 0.40, renderCell: (params) => (
                    <Box component={'div'}>
                        {params?.row?.bank_name ? params?.row?.bank_name?.length > 25 ?
                            <Tooltip placement="top" title={params?.row?.bank_name}><Typography fontSize={'0.9vw'}>{params?.row?.bank_name?.slice(0, 25) + '...'}</Typography></Tooltip> :
                            <Typography fontSize={'0.9vw'}>{params?.row?.bank_name}</Typography> : '-'}
                    </Box>
                )
            },
            {
                field: 'bank_account_number', headerName: t('Account Number'), sortable: false, flex: 0.40, renderCell: (params) => (
                    <Box component={'div'}>
                        {params?.row?.bank_account_number ? params?.row?.bank_account_number?.length > 25 ?
                            <Tooltip placement="top" title={params?.row?.bank_account_number}><Typography fontSize={'0.9vw'}>{params?.row?.bank_account_number?.slice(0, 25) + '...'}</Typography></Tooltip> :
                            <Typography fontSize={'0.9vw'}>{params?.row?.bank_account_number}</Typography> : '-'}
                    </Box>
                )
            },
            {
                field: 'actions', headerAlign: 'center', headerName: t('Action'), flex: 0.15, sortable: false, hideable: false, align: "center", renderCell: (params) => {
                    return (
                        <CommonDeleteButton
                            disable={!CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Bank & Account Setup", "SubTab")?.editAccess}
                            size="1.5vw"
                            onClick={() => { this.handledelete(params?.row) }} />
                    )
                }
            }
        ]
        return (
            <Box id="eMed_srvConfig_Container" sx={{ backgroundColor: Colors.configHomeBg }}>
                <Grid container spacing={3} className="eMed_srvConfig_Box">
                    <Grid item xs={7.6}>
                        <Paper className="eMed_srvConfig_Div" >
                            <DataGrid
                                rows={bankMasterList}
                                columns={columns}
                                getRowId={(row) => row.id}
                                localeText={{
                                    toolbarColumns: "",
                                    toolbarDensity: "",
                                    toolbarExport: "",
                                    toolbarFilters: "",
                                    toolbarExportPrint: ""
                                }}
                                disableSelectionOnClick
                                components={{
                                    Toolbar: CommonGridHeader.CommonToolBar,
                                    NoRowsOverlay: () => {
                                        return (
                                            <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "53vh" }}>
                                                {t("NoRecordsFound")}
                                            </Stack>
                                        )
                                    }
                                }}
                                headerHeight={40}
                                rowCount={bankMasterList.length}
                                page={current_page}
                                onPageChange={(newPage) => this.setState({ current_page: newPage })}
                                pageSize={rowsPerPage}
                                onPageSizeChange={(newPageSize) => this.setState({ rowsPerPage: newPageSize })}
                                rowsPerPageOptions={[10, 20, 30]}
                                pagination
                                loading={this.state.isLoader}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={4.4}>
                        <Paper className="eMed_srvConfig_Div">
                            <div className='eMed_srvConfig_rightHead' style={{ backgroundColor: Colors.DataTblHeaderbg }}>
                                <p className='eMed_srvConfig_rightHead_txt'>{t('Bank & Account Setup')}</p>
                            </div>
                            <div className="eMed_srvConfig_subDiv">
                                {this.renderTextBox("Bank Name", "bankName")}
                                {this.renderTextBox("Account Number", "accountNo")}
                            </div>
                            <Stack spacing={2} direction="row" id='eMed_srvConfig_rightBtnCon' sx={{ backgroundColor: Colors.DataTblHeaderbg }} alignItems="center" justifyContent="center">
                                <Button variant='outlined' size="small" id="eMed_Config_btn" onClick={() => { this.handleClear() }}>{t("Clear")}</Button>
                                <Button disabled={this.state.disableBtn ? true : !CheckAccessFunc("front_office", "Settings", "Hospital Configuration", "Bank & Account Setup", "SubTab")?.editAccess} variant='contained' size="small" id="eMed_Config_btn" emed_tid="Specializaton_Save_Btn" onClick={() => { this.handleSave() }}>{t("Save")}</Button>
                            </Stack>
                        </Paper>
                    </Grid>
                </Grid>
                {
                    this.state.showSuccessResponse ? <ToastMsg severity={"success"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
                {
                    this.state.showErrorResponse ? <ToastMsg severity={"error"} msg={this.state.responseMessage} msgPop={this.msgClose.bind(this)} /> : null
                }
                {this.state.bankData !== null ? <DeletePopup
                    DeletTitle={`${t("deleteMsg")} ${this.state.bankData ? this.state.bankData?.bank_name : "-"} ${t("Bank Data")} ?`}
                    deleteAlertPopupClose={this.popupClose.bind(this)}
                    removeData={this.deletePov.bind(this)}
                /> : null}
            </Box>
        )
    }
}
export default withTranslation()(BankDetailsMaster);